import { Form, InputNumber, Table, Typography, Input, Space, Button, notification } from 'antd';
import { SearchOutlined } from '@ant-design/icons'
import { useState, useRef, useEffect } from 'react';
import Highlighter from 'react-highlight-words'
import { useAtom } from 'jotai'
import { useMsal } from '@azure/msal-react';

import { selectedRecord, accessTokenAtom } from "../atoms";


let tablelabel;

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;

    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

const EnergyTableComponent = ({ defaultColumns, dummyData, label, radio = true, token }) => {
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([...dummyData]);
    const [searchText, setSearchText] = useState('')
    const [searchedColumn, setSearchedColumn] = useState('')
    const searchInput = useRef(null)
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.id === editingKey;
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [api, contextHolder] = notification.useNotification();
    const [currentRecord, setCurrentRecord] = useAtom(selectedRecord);
    const [currentRows, setCurrentRows] = useState(5);
    const [accessAtom] = useAtom(accessTokenAtom)
    const { instance, accounts } = useMsal();
    useEffect(() => {
        setDataSource([...dummyData])
    }, [dummyData])


    tablelabel = label

    const openNotification = () => {
        api.error({
            message: `Delete Error`,
            description:
                'Delete Error Content',
            placement: 'top',
        });
    };

    const handleEdit = (record) => {
        // use setFieldsValue to be able to validate fields when saving
        // use the href attribute for the certificate field because it
        // is an href object

        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.id);
    };

    const handleCancel = () => {
        setEditingKey('');
    };

    const handleSave = async (record) => {
        try {
            const row = await form.validateFields();
            const newData = [...dataSource];
            const index = newData.findIndex((item) => record.id === item.id);

            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });

                console.log(newData)

                setDataSource(newData);

                let inputData = {}
                if (typeof newData[index].isRenewal === 'string') {
                    inputData = {
                        ...newData[index],
                        isRenewal: newData[index].isRenewal.toLowerCase() == "true" ? true : false,
                    }
                }
                else {
                    inputData = {
                        ...newData[index],
                        modifiedBy: accounts[0].name,
                    }
                }

                fetch(`${process.env.REACT_APP_API_URL}EnergyPlan/${record.id}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify(inputData)
                })
                setEditingKey('');
            } else {
                newData.push(row);
                setDataSource(newData);
                setEditingKey('');
            }
        } catch (errInfo) {

        }
    };

    const handleDelete = (record) => {
        const newData = dataSource.filter((item) => item.id !== record.id);
        fetch(`${process.env.REACT_APP_API_URL}ActiveProject/DeleteProject?projectId=${record.id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        })
        setDataSource(newData);
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText((selectedKeys.length === 0 && '') || selectedKeys[0])
        setSearchedColumn(dataIndex)
    }

    const handleReset = (clearFilters, confirm, dataIndex) => {
        clearFilters()
        handleSearch([], confirm, dataIndex)
    }

    function isIsoDate(str) {
        return ((/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{0,3}$/.test(str)) || (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(str)))
    }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, confirm, dataIndex)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex] != null ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : null,
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100)
            }
        },
        render: (text, record) => {
            let dateDisplay;
            if (isIsoDate(text)) {
                const date = new Date(text);
                // Get the day, month, and year from the date object
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // month is 0-indexed
                const year = date.getFullYear().toString();
                // Combine the day, month, and year into a single string with the desired format
                dateDisplay = `${day}-${month}-${year}`;
            }

            return (
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{
                            backgroundColor: '#ffc069',
                            padding: 0,
                        }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={isIsoDate(text) ? dateDisplay : text ? text.toString() : ''}
                    />
                ) : (
                    isIsoDate(text) ? dateDisplay : text
                )
            )
        }
    })

    const columns = defaultColumns.map((col) => {
        // Column certificate doesnt need to have search filter
        // CHANGE THIS LINK TO BACK TO CERTIFICATE FOR RESIDENTIAL
        if (col.dataIndex === 'isRenewal') {
            return col
        }

        // Add a search filter functionality
        const newCol = {
            ...col,
            ...getColumnSearchProps(col.dataIndex),
        }

        if (col.dataIndex !== 'operation') {
            return newCol
        }

        // Add edit and delete functionality under the column "operation"
        return {
            ...col,
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                            onClick={() => handleSave(record)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Save
                        </Typography.Link>
                        <Typography.Link
                            onClick={handleCancel}
                            style={{
                                marginRight: 0,
                            }}
                        >
                            Cancel
                        </Typography.Link>
                    </span>
                ) : (
                    <span>
                        <Typography.Link disabled={editingKey !== ''} onClick={() => handleEdit(record)} style={{ 'marginRight': '8px' }}>
                            Edit
                        </Typography.Link>
                        { }
                    </span>
                );
            },
        }
    })

    // Make the cell of each row editable
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ? 'number' : col.dataIndex === 'category' ? 'input' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    const components = {
        body: {
            cell: EditableCell,
        },
    }

    return (
        <div style={{}}>
            {contextHolder}
            <Form form={form} component={false}>
                <Table
                    summary={(data) => {
                        // parse the certificate object
                        // get only the href string
                        const x = data.map(d => ({
                            ...d,
                            // ...("certificate" in d && {certificate: d.certificate?.props?.href}),
                            ...("projectLink" in d && { link: d.link?.props?.href })
                        }))

                        // Summary needs to return a React.ReactNode
                        // We need this so that we can get a reference
                        // to the current data of the table when we
                        // export to excel or pdf 
                        return (
                            <>
                                <Table.Summary.Row>
                                    <Table.Summary.Cell className='test-data d-none'>
                                        {JSON.stringify(x)}
                                    </Table.Summary.Cell>
                                </Table.Summary.Row>
                            </>
                        )
                    }}
                    components={components}
                    bordered
                    dataSource={[...dataSource]}
                    columns={mergedColumns}
                    rowKey={"id"}
                    rowClassName="editable-row"
                    pagination={{
                        pageSize: currentRows,
                        onChange: (page, pageSize) => setCurrentRows(pageSize),
                        showSizeChanger: true
                    }}
                />
            </Form>

        </div>
    );
};

export default EnergyTableComponent;